import React from 'react'
import styled from 'styled-components'
import { magicContainerStyle, titleStyle2 } from 'components/magic/styled'
import mediaQuery from 'styles/mediaQuery'
import GetStartedButton from 'components/magic/GetStartedButton'
import colors from '../../../styles/colors'

const Section = styled.section`
  position: relative;
  width: 100%;
  padding: 60px 0;
  color: ${colors.gray2};
`

const Container = styled.div`
  ${magicContainerStyle};

  ${mediaQuery.bigTabletMin} {
    display: flex;
  }
`

const Title = styled.h4`
  ${titleStyle2};
  margin-bottom: 24px;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  border-radius: 40px;
  overflow: hidden;
  border: 1px solid #333;
  padding: 130px 15px;
  position: relative;
  background-color: ${({ isDark }) => (isDark ? '#18181C' : 'transparent')};

  & > * {
    position: relative;
    z-index: 1;
  }

  &:after,
  &:before {
    content: '';
    position: absolute;
    border: 1px solid #333;
    border-radius: 50%;
  }

  &:after {
    width: 456px;
    height: 456px;
    left: -220px;
    bottom: -220px;
  }

  &:before {
    width: 242px;
    height: 242px;
    top: -93px;
    right: -93px;
  }
`

const StartSelling = ({ isDark }) => (
  <Section>
    <Container>
      <Wrapper isDark={isDark}>
        <Title>Start selling on Flip today</Title>
        <GetStartedButton />
      </Wrapper>
    </Container>
  </Section>
)

export default StartSelling
